"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isShipUserID = void 0;
const isShipUserID = (id) => id?.startsWith('U-') ?? false;
exports.isShipUserID = isShipUserID;
//# sourceMappingURL=utils.js.map